import { AlertTriangle, Inbox } from "lucide-react";
import type { ReactNode } from "react";

export function LoadingState({ label = "Loading" }: { label?: string }) {
  return (
    <div className="state-row" role="status">
      <span className="spinner" />
      {label}
    </div>
  );
}

export function ErrorState({ error }: { error: Error }) {
  return (
    <div className="state-row error-state" role="alert">
      <AlertTriangle size={17} aria-hidden="true" />
      <span>{error.message}</span>
    </div>
  );
}

export function EmptyState({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="empty-state">
      <Inbox size={22} aria-hidden="true" />
      <strong>{title}</strong>
      {children}
    </div>
  );
}
